var BaseView = require('./view');

module.exports = BaseView.extend({
  template: require('./logos.hbs'),
  applyElementEvent: function (event) {
    var $thumbnail = $(event.currentTarget).closest('.thumbnail');

    this.trigger('apply', {
      thumb_src: $thumbnail.data('thumb'),
      is_vector: $thumbnail.data('isvector')
    });
  },

  removeElementEvent: function (event) {
    var thumb = $(event.currentTarget).closest('.thumbnail').data('thumb');
    this.data = _(this.data).filter(function (logo) {
      return logo['thumb_src'] != thumb;
    });

    this.render();
    this.trigger('change', this.getData());
    event.stopPropagation();
  },

  render: function () {
    this.$el.html(this.template({
      uuid: this.uuid,
      data: this.data,
      no_data: this.data.length < 1,
      show_hint: this.data.length == 1
    }));
  }
});
